<template>
  <div class="solutionDetail">
    <div id="div_banner" class="banner1">
      <img src="../../assets/20170405181233_4368.jpg" alt="解决方案">
    </div>
    <div class="cases_main">
      <div class="box clearfix">
        <div class="fixed" style="position: fixed">
          <ul id="ul_list">
            <li v-for="(item,idx) in SolutionDate">
              <a v-if="idx === 0 || idx === 6" style="font-size: 20px;font-weight: 800;color: #343858;height: 80px;line-height: 80px;">{{item.fsolutionName}}</a>
              <a v-else @click="getSolutionDetailDate(item.fsolutionId)"  :id="item.fsolutionId" :key="idx" style="cursor: pointer;height: 50px;border-top: 1px solid #ccc">{{item.fsolutionName}}</a>
            </li>
          </ul>
        </div>
        <div id="div_content" class="cases_wrap">
          <div class="cases_list">
            <div class="text" v-html="solutionDetail.fsolution">
            </div>
          </div>
          <div class="cases_list">
            <h2>成功案例</h2>
            <div class="text">
              <div id="div_caseList" class="cases_slide" v-html="CaseDate.fcase">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from '../../../static/js/commonAxios'
  import $ from 'jquery'
    export default {
      name: "solution-detail",
      data(){
        return{
          SolutionDate:[],
          solutionDetail:'',
          solutionId:this.$route.query.id,
          CaseDate:'',
        }
      },
      mounted(){
        this.getSolutionDate()
        this.getSolutionDetailDate(this.solutionId)
      },
      methods:{
        getSolutionDetailDate(id){
          axios.get(`/api/solution/${id}`).then((res) => {
            if(res.data.success){
              this.solutionDetail = res.data.items[0]
              this.$nextTick(()=>{
                $('.cases_main .fixed li a').removeClass('active')
                $("#"+id).addClass('active')
              })
              this.getCaseDate(id)
            }else{
              this.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          })
        },
        getCaseDate(id){
          axios.get(`/api/case?fsolutionId=${id}`).then((res) => {
            if(res.data.success){
              this.CaseDate = res.data.items[0]
            }else{
              this.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          })
        },
        getSolutionDate(){
          axios.get('/api/solution').then((res) => {
            if(res.data.success){
              this.SolutionDate = res.data.items
              res.data.items.forEach((ele)=>{
                if(this.solutionId ===ele.fsolutionId){
                  this.$nextTick(()=> {
                    $("#" + ele.fsolutionId).addClass('active')
                  })
                }
              })
            }else{
              this.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          })
        },
      }
    }
</script>

<style scoped>
  .cases_main{
    width: 100%;
    padding-top: 80px;
  }
  .cases_main .fixed{
    width: 190px;
    padding: 15px 20px 40px;
    background: #fff;
    border-radius: 10px;
    float: left;
    z-index: 1000;
  }
  .cases_main .fixed li a{
    display: block;
    width: 190px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #666;
    /*border-bottom: 1px solid #ccc;*/
    text-decoration: none;
  }
  .cases_main .fixed li .active{
    /*background: url(../../assets/67.jpg) no-repeat left center;*/
    font-weight: bold;
    color: #fff;
    background: #98C73C;
  }
  .cases_main .fixed li  a:hover{
    font-weight: bold;
    /*color: #333;*/
  }
  .cases_main .cases_wrap{
    width: 990px;
    float: right;
  }
  .cases_main .cases_wrap .cases_list{
    background: #fff;
    padding:20px;
  }
  .cases_main .cases_wrap .cases_list h2{
    width: 950px;
    line-height: 60px;
    height: 60px;
    font-size: 18px;
    color: #333;
    font-weight: bold;
    /*border-bottom: 1px solid #ccc;*/
  }
  .cases_main .cases_wrap .cases_list .text{
    width: 950px;
    font-size: 14px;
    line-height: 30px;
    color: #333;
  }
  .cases_main .cases_wrap .cases_list .text img{
    display: block;
    width:100%;
  }
  .cases_main .cases_wrap .cases_list .pic_box{
    text-align: center;
    margin-top: 20px;
  }
  .cases_main .cases_wrap .cases_list .text span{
    display: block;
    margin-bottom:15px;
    color: #333;
    font-size: 18px;
    font-weight: bold;
    margin-top: 15px;
  }
  .cases_main .cases_wrap .cases_list  .swiper-slide{

  }
  .cases_main .cases_wrap .cases_list  .swiper-slide .pic_box1{
    width: 310px;
    height: 160px;
  }
  .cases_main .cases_wrap .cases_list .cases_slide{
    /*height: 220px;*/
    position: relative;
  }
  .cases_main .cases_wrap .cases_list .swiper-slide h3{
    width: 310px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    background: #36395a;
    color:#fff;
  }
  /*.cases_main .cases_wrap .prev,.cases_main .cases_wrap .next{*/
    /*width: 38px;*/
    /*height: 38px;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*margin-top: -14px;*/
  /*}*/
  /*.cases_main .cases_wrap .prev{*/
    /*left: -100px;*/
    /*background: url(../../assets/) no-repeat center center;*/
  /*}*/

  /*.cases_main .cases_wrap .next{*/
    /*right: -100px;*/
    /*background: url(../images/55.png) no-repeat center center;*/
  /*}*/

  /*.tbg{*/
    /*background: url(../images/60.png) no-repeat center 15px ;*/
  /*}*/
  @media screen and (max-width: 1024px){
    .cases_main .fixed {
      width: 100%;
      position: static !important;
    }
    .cases_main .fixed li a {
      width: 100%;
    }
    .cases_main .cases_wrap{
      width: 100%;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/solution/solutionDetail.vue